import styled, {css, keyframes} from 'styled-components';
import {StepStatus} from './types';
import {device} from 'styled/device';
import Webcam from 'components/Webcam';
import Lottie from 'lottie-react';
import {isMobile} from 'react-device-detect';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const SpecialIndicator = styled.div`
  border-radius: 50%;
  position: absolute;
  top: 4px;
  right: 4px;
  height: 2px;
  width: 2px;
  background: #ffffff;
  z-index: 2;
`;

export const VideoContainer = styled.div<{$status?: StepStatus}>`
  position: relative;

  .webcam__scan-area {
    ${({$status}) => {
      switch ($status) {
        case 'success':
          return css`
            border-color: #32d7be;
          `;
        case 'error':
          return css`
            border-color: #f44336;
          `;
      }
    }}
  }
`;

export const WebcamStyled = styled(Webcam)`
  border-radius: 12px;
  background: ${({theme}) => theme.colors.$p6};
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  max-width: 420px;
  max-height: 262px;

  @media (min-width: ${device.tablet}) {
    width: 410px;
    height: 262px;
    max-width: 410px;
    max-height: 262px;
  }
`;

export const InstructionsContainer = styled.div`
  margin-top: 24px;
  text-align: center;
  width: 100%;
  max-width: 500px;
  color: #333;
`;

export const InstructionText = styled.p<{$status: StepStatus}>`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
  transition: color 0.3s ease;

  ${({$status}) => {
    switch ($status) {
      case 'error':
        return css`
          color: #f44336;
        `;
      default:
        return css`
          color: inherit;
        `;
    }
  }}
`;

export const LottieStatusIcon = styled(Lottie)`
  width: 72px;
  height: 72px;
  margin: 0 auto;
`;

export const LottieHelperIcon = styled(Lottie)`
  width: 128px;
  height: 96px;
  margin: 0 auto;

  path {
    stroke: #152946;
  }

  ${
    isMobile &&
    css`
      path {
        stroke: #ffffff;
      }
    `
  }
  }
`;
